export default __webpack_public_path__ + "static/media/attraction4.510d779f.jpg";